import { hamburger } from "../components/hamburger/hamburger";
import { lightbox } from "../components/image-gallery/image-gallery";
import { accordion } from "../components/accordion/accordion";
import { stickyHeader } from "../components/sticky-header/sticky-header";
import { stickyFooter } from "../components/sticky-footer/sticky-footer";
import { initializeKuferCourseLoader } from "../components/kufer-kurs-loader/kufer-kurs-loader";
import { initializeKuferSearch } from "../components/kufer-search/kufer-search";
import { filterDate } from "../components/filter-date/filter-date";
import { wpformsCustom } from "../components/wpforms-custom/wpforms-custom";
import { newsPopup } from "../components/news-popup/news-popup";
import { loginStatus } from "../components/login-status/login-status";
//import { loadUserFavorites } from "../components/kufer-utils/kufer-favorites";
//import { updateFavButtonVisual } from "../components/kufer-utils/kufer-favorites";
//import { toggleFavoriteRequest } from "../components/kufer-utils/kufer-favorites";
import { initializeDetailFavorites } from "../components/kufer-utils/kufer-favorites";
import $ from "jquery";

//import { scrollR } from "../components/scroll-reveal/scroll-reveal";
//import { isotopeGallery } from "../components/isotope-gallery/isotope-gallery";
//import { objektSliderLightbox } from "../components/image-gallery/image-gallery";
//import { objektDetailTabs } from "../components/objekt-detail-tabs/objekt-detail-tabs";
//import { objektImages } from "../components/image-slider/image-slider";
//import { quoteSlider } from "../components/image-slider/image-slider";
//import { exposeAnfordern } from "../components/expose/expose";

document.addEventListener("DOMContentLoaded", function () {
  hamburger();
  stickyHeader();
  stickyFooter();
  accordion();
  lightbox();
  initializeKuferCourseLoader();
  initializeKuferSearch();
  filterDate();
  wpformsCustom();
  newsPopup();
  loginStatus();
  //loadUserFavorites();
  //updateFavButtonVisual();
  //toggleFavoriteRequest();
  initializeDetailFavorites();
  //isotopeGallery();
  //scrollR();
  //quoteSlider();
  //objektSliderLightbox();
  //imageGallerySlider();
  //heroSlider();
  //sliderTextGrid();
  //objektDetailTabs();
  //objektImages();
  //exposeAnfordern();
  //quoteSlider();
});
